import React from "react";

import WelcomeContainer from "components/WelcomeContainer";
import Camera from "components/Camera";
import Modal from "components/Modal";
import { useSelector } from "react-redux";
import Cookie from "universal-cookie";
import { useHistory } from "react-router-dom";
import Countdown from "react-countdown";

const cookie = new Cookie();

export default function WelcomeLJILite(props) {
  const general = useSelector((state) => state.general);
  const history = useHistory();

  const TOTAL_TIME = 20 * 60 * 1000;

  const getRemaining = () => {
    const startTime = cookie.get("start_time_lji_lite");
    if (!startTime) return TOTAL_TIME;
    const elapsed = Date.now() - parseInt(startTime);
    return Math.max(0, TOTAL_TIME - elapsed);
  };

  const clickAgree = () => {
    history.push("/lji-lite/assestment");
  };

  const handleTimeUp = () => {
    history.push("/lji-lite/assestment");
  };

  return (
    <div>
      <Modal token={props.token} profile={props.profile} />

      {general.on_cam && <Camera profile={props.profile} />}
      <WelcomeContainer
        key="lji-lite"
        ln="id"
        btnText="Mulai"
        clickAgree={clickAgree}
        welcomeMessage="Anda akan menjalani Leadership Judgement Indicator Test (LJI – Lite). Perhatikan waktu pengerjaan Anda. Anda dapat sewaktu-waktu membuka kembali gambaran umum dan petunjuk pengisian ini dengan mengklik di bagian kanan atas sebelah waktu."
        timerComponent={
          <div
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffc107",
              borderRadius: 8,
              padding: "10px 16px",
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "50%",
              marginBottom: 8,
            }}
          >
            <span style={{ fontSize: 18 }}>⏱</span>
            <div
              style={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
              }}
            >
              <span style={{ margin: 0, fontSize: 12, color: "#666" }}>
                Waktu pengerjaan sudah berjalan
              </span>
              <Countdown
                date={Date.now() + getRemaining()}
                onComplete={handleTimeUp}
                renderer={({ hours, minutes, seconds }) => (
                  <span
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      color: "#e53935",
                    }}
                  >
                    {hours > 0 ? `${String(hours).padStart(2, "0")}:` : ""}
                    {String(minutes).padStart(2, "0")}:
                    {String(seconds).padStart(2, "0")}
                  </span>
                )}
              />
            </div>
          </div>
        }
      >
        <div className="welcome-mobile">
          <h3 style={{ color: "#00abbd" }}>
            Petunjuk pengisian Leadership Judgement Indicator - Lite
          </h3>

          <p>
            Tes ini bertujuan untuk mengukur kualitas pertimbangan (
            <i>judgement</i>) dan pengambilan keputusan Anda dalam situasi
            kepemimpinan yang berkaitan dengan pengelolaan individu maupun tim
            kerja.
          </p>

          <p>
            Anda akan dihadapkan pada sejumlah situasi yang umum dijumpai dalam
            konteks kepemimpinan di lingkungan kerja. Setiap situasi akan
            disertai dengan empat alternatif tindakan yang dapat dilakukan dalam
            merespons kondisi tersebut.
          </p>

          <p>
            Instrumen ini terdiri dari <b>15 situasi kepemimpinan</b>, di mana
            setiap situasi dirancang untuk menggambarkan tantangan pengambilan
            keputusan dalam konteks <i>people management</i> di lingkungan
            organisasi.
          </p>

          <h4 style={{ marginTop: 20, color: "#78000F" }}>Tugas Anda:</h4>
          <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
            <li>
              Untuk setiap situasi yang diberikan, Anda diminta untuk{" "}
              <b>memilih satu tindakan</b> yang menurut penilaian Anda merupakan
              respons yang <b>paling efektif dan paling tepat</b> untuk
              dilakukan dalam kondisi tersebut.
            </li>
            <li>
              Jawaban yang Anda pilih diharapkan mencerminkan tindakan yang
              paling mungkin Anda ambil dalam situasi nyata di lingkungan kerja,
              bukan tindakan yang dianggap paling ideal secara teoritis.
            </li>
            <li>
              Tidak terdapat jawaban yang secara mutlak benar atau salah;
              penilaian difokuskan pada kualitas <i>leadership judgement</i>{" "}
              yang tercermin dari keputusan yang Anda ambil.
            </li>
            <li>
              Seluruh soal wajib dijawab dalam batas waktu yang telah
              ditentukan.
            </li>
            <li>
              Anda tidak diperkenankan untuk mendiskusikan, merekam, menyalin,
              atau menyebarluaskan materi tes dalam bentuk apa pun.
            </li>
          </ul>

          <h4 style={{ marginTop: 20, color: "#78000F" }}>Waktu Pengerjaan:</h4>
          <p>
            Durasi waktu yang dialokasikan untuk mengerjakan seluruh soal adalah
            sekitar <b>12 – 15 menit</b>.
          </p>

          <p style={{ marginTop: 20, fontStyle: "italic" }}>
            Dengan memulai tes, Anda menyatakan telah memahami dan menyetujui
            seluruh ketentuan yang berlaku.
          </p>

          <p style={{ marginTop: 20, fontWeight: "bold", textAlign: "center" }}>
            Selamat mengerjakan!
          </p>
        </div>
      </WelcomeContainer>
    </div>
  );
}
